export const groupBookingKeys = {
    all: ['groupBooking'] as const,
    reservations: (sessionId: string) => ['groupBooking', 'reservations', sessionId] as const,
    memberBookings: (memberId: string) => ['groupBooking', 'member', memberId] as const,
};
